module.exports = __webpack_public_path__ + "img/Harsh Rajat.960654df.jpg";